import { ModalContext, type ModalContextType } from "./ModalContext";
import Modal from "../modals/Modal";
import { useState, type ReactNode } from "react";
import type { ModalConfig } from "../utils/types";

interface ModalContextProviderProps {
  children: ReactNode;
}

export const ModalContextProvider = ({ children }: ModalContextProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState<ModalConfig | undefined>();

  const value: ModalContextType = {
    openModal: (config: ModalConfig) => {
      setIsModalOpen(true);
      setModalConfig(config);
    },
    closeModal: () => {
      setIsModalOpen(false);
    },
    isModalOpen,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
      {isModalOpen && modalConfig && (
        <Modal
          title={modalConfig.title}
          body={modalConfig.body}
          buttons={modalConfig.buttons}
          showCloseButton={modalConfig.showCloseButton}
        />
      )}
    </ModalContext.Provider>
  );
};

